import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import {
  displayFormattedDate,
  formatCurrency,
  isEmpty,
} from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import {
  EditOutlined,
  EyeOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

function DebitNoteBillwiseTable(props) {
  const columns = [
    {
      title: "DN Number",
      dataIndex: "id",
      width: "100px",
    },
    {
      title: "Creditor",
      dataIndex: "creditor",
    },
    {
      title: "Date",
      dataIndex: "debitNoteDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Narration",
      dataIndex: "narration",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text) => formatCurrency(text)
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined/>
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined/> / <PrinterOutlined/>
          </Button>
          {/* <Button
            size="small"
            // onClick={() => handlePrint(record)}
          >
            Print
          </Button> */}
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    "/debitNoteBillwise",
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/debitNoteBillwise?pageNumber=${1}`);
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);

  const editRecord = (record, isViewOnly = false) => {
    if (isViewOnly) {
      navigate("/portal/debitNoteBillwise/view", {
        state: { debit_note_id: record.id, isViewOnly: isViewOnly },
      });
    } else {
      navigate("/portal/debitNoteBillwise/edit", {
        state: { debit_note_id: record.id, isViewOnly: isViewOnly },
      });
    }
  };

  const onDebitNoteBillwiseSearch = (id) => {
    if (!isEmpty(id))
      navigate("/portal/debitNoteBillwise/view", {
        state: { debit_note_id: id, isViewOnly: false },
      });
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/debitNoteBillwise?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Debit Notes</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              prefix="DN-"
              placeholder="Debit Note Number"
              allowClear
              enterButton="Search"
              onSearch={onDebitNoteBillwiseSearch}
            />
            <Button>
              <Link to="add">Add Debit Note Billwise</Link>
            </Button>
            {/* <Button
              type="primary"
              //onClick={handlePrint}
              disabled={selectedRows.length === 0}
            >
              Print Selected Debit Notes
            </Button> */}
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        rowSelection={rowSelection}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </>
  );
}

export default DebitNoteBillwiseTable;
